import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CartEditItemPage } from 'src/app/modals/cart-edit-item/cart-edit-item.page';
import { ReplacePipe } from 'src/app/replace.pipe';

const routes: Routes = [
  {
    path: '',
    component: CartEditItemPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CartEditItemPage,ReplacePipe]
})
export class CartEditItemPageModule {}
